import { render } from "./Contactus.vue?vue&type=template&id=a364d418&scoped=true"
import script from "./Contactus.vue?vue&type=script&lang=js"
export * from "./Contactus.vue?vue&type=script&lang=js"

import "./Contactus.vue?vue&type=style&index=0&id=a364d418&lang=scss&scoped=true"

import exportComponent from "D:\\code\\h5\\officialWeb-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a364d418"]])

export default __exports__